import { APIBinderData } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation, validateFailedObjects } from '../utils/helpers';

export const processGraduatedLicensingData = (
  binderReportData: APIBinderData,
  remarks: Remark[] = [],
  validation?: Validation,
): BinderSectionData => {
  const mvrData = binderReportData?.mvr_data || [];
  const drivers = binderReportData?.application_data?.drivers || [];

  const driverRows = drivers.map((driver, index: number) => {
    const mvrIssueDate = mvrData[index]?.license_issue_date || '';
    const quoteG1Date = drivers[index]?.g1_date || '';
    const isValid = validateFailedObjects(index, validation);

    return {
      driverName: driver?.name || '',
      mvrIssueDate: mvrIssueDate,
      quoteG1Date: quoteG1Date,
      driverIndex: index,
      remarks: remarks.find((r) => r.item_key === `driver-${index + 1}`)?.text,
      isValid,
    };
  });

  const validationData = processValidation(validation);

  return {
    title: 'Graduated licensing',
    description:
      'Check to ensure that the graduated licensing date is correct.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      driverRows,
    },
  };
};
